import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-size-14"
}
const _hoisted_3 = { class: "d-flex justify-content-end align-items-center" }

import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuLinkItemContent',
  props: {
  label: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "left"),
      _createTextVNode(),
      (props.label)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(props.label), 1))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "right"),
        _createTextVNode(),
        _createVNode(FeatherIcon, {
          icon: "chevron-right",
          size: "1x",
          class: "text-gray-05 ml-2"
        })
      ])
    ]),
    _createTextVNode(),
    _renderSlot(_ctx.$slots, "bottom")
  ], 64))
}
}

})